import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'weekCalendar.header.label',
    defaultMessage: 'Week {currentWeek} of {weeks} - {month} {year}'
  }
});
